import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import TranchesscolaritesService from "./TranchesscolaritesService";
import Joi from "joi-browser";
import StatutsService from "../statuts/StatutsService";
import Filarial from "../include/filarial";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";


export default function TranchesscolaritesIndex() {
    const activeLink = "TRANCHES SCOLARITES"

    const token = useSelector(state => state.auth.token)
    const [tranchesscolarites, setTranchesscolarites] = useState([])
    //const [tranchescolariteId, setTranchescolariteId] = useState('');

    const [statuts, setStatuts] = useState([])

    const [errors, setErrors] = useState({});

    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const [addFormData, setAddFormData] = useState({
        libelleTrancheScolarite: '',
        descriptionTrancheScolarite: '',
        pourcentageTrancheScolarite: '',
        datedelaiTrancheScolarite: ''
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        libelleTrancheScolarite: '',
        descriptionTrancheScolarite: '',
        pourcentageTrancheScolarite: '',
        datedelaiTrancheScolarite: '',
        statutId: '',
        id: ''
    });


    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)


    //get liste matieres
    const fetchTranchesscolarites = async () => {
        await TranchesscolaritesService.index(token).then((res) => {
            //console.log(res.data.data)
            setTranchesscolarites(res.data.data.tranchesscolarites)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        libelleTrancheScolarite: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionTrancheScolarite: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        pourcentageTrancheScolarite: Joi.number().integer().min(1).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 1 %", max: "maximum 100%" , integer: 'Doit être un nombre entier'},
            },
        }).label("Pourcentage Tranche"),

        datedelaiTrancheScolarite: Joi.date().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Delai Tranche"),
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {

        libelleTrancheScolarite: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionTrancheScolarite: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        pourcentageTrancheScolarite: Joi.number().integer().min(1).max(100).required("").empty('').options({
            language: {
                any: { required: 'Le champ est obligatoire' },
                number: { min: "Minimum 1 %", max: "Maximum 100%", integer: 'Doit être un nombre entier' },
            },
        }).label("Pourcentage Tranche"),        

        datedelaiTrancheScolarite: Joi.date().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Delai Tranche"),

        statutId: Joi.number().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Statut"),

        id: Joi.number().min(1).empty('').options({
            language: {
                string: { min: "minimum 1" },
            },
        }).label("Id")
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleTrancheScolarite: '',
            descriptionTrancheScolarite: '',
            pourcentageTrancheScolarite: '',
            datedelaiTrancheScolarite: ''
        });
    };


    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                TranchesscolaritesService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchTranchesscolarites()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //get liste statuts
    const fetchStatuts = async () => {
        await StatutsService.index(token).then((res) => {
            setStatuts(res.data.data.statuts)
        }).catch(error => {
            console.log(error)
        })
    }

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData({ ...editFormData, [name]: value });
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Enregistrer une nouvelle tranche
    const handleStore = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await TranchesscolaritesService.store(addFormData, token).then(response => {
                //Fermer le modal
                setIsVisible(false)
                //Vider les champs du formulaire
                clearForm()
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des roles
                    fetchTranchesscolarites()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'ajout de tranche
    const addModalContent = (
        <Form className="needs-validation row" noValidate onSubmit={handleStore}>
            <div className="col-md-12 mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Libelle <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-libelleTrancheScolarite"
                    type="text"
                    value={addFormData.libelleTrancheScolarite}
                    onChange={handleChange}
                    required={true}
                    name="libelleTrancheScolarite"
                />

                {errors.libelleTrancheScolarite && (
                    <div className="alert alert-danger">
                        {errors.libelleTrancheScolarite}
                    </div>
                )}
            </div>

            <div className="col-md-6 mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Pourcentage <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-pourcentageTrancheScolarite"
                    type="number"
                    value={addFormData.pourcentageTrancheScolarite}
                    onChange={handleChange}
                    required={true}
                    name="pourcentageTrancheScolarite"
                />

                {errors.pourcentageTrancheScolarite && (
                    <div className="alert alert-danger">
                        {errors.pourcentageTrancheScolarite}
                    </div>
                )}
            </div>

            <div className="col-md-6 mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Date délai <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-datedelaiTrancheScolarite"
                    type="date"
                    value={addFormData.datedelaiTrancheScolarite}
                    onChange={handleChange}
                    required={true}
                    name="datedelaiTrancheScolarite"
                />

                {errors.datedelaiTrancheScolarite && (
                    <div className="alert alert-danger">
                        {errors.datedelaiTrancheScolarite}
                    </div>
                )}
            </div>

            <div className="col-md-12 mb-2">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionTrancheScolarite" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionTrancheScolarite"
                    onChange={handleChange}
                    name="descriptionTrancheScolarite"
                    rows="3"
                    value={addFormData.descriptionTrancheScolarite}
                ></textarea>

                {errors.descriptionTrancheScolarite && (
                    <div className="alert alert-danger">
                        {errors.descriptionTrancheScolarite}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await TranchesscolaritesService.show(id, token).then((response) => {
            const data = response.data.data;
            //console.log(response.data.data)
            setEditFormData({
                libelleTrancheScolarite: data.libelleTrancheScolarite,
                descriptionTrancheScolarite: data.descriptionTrancheScolarite,
                pourcentageTrancheScolarite: data.pourcentageTrancheScolarite,
                datedelaiTrancheScolarite: data.datedelaiTrancheScolarite,
                statutId: data.statuts.id,
                id: id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //Modification d'une tranche
    const handleUpdate = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await TranchesscolaritesService.update(editFormData, token).then(response => {

                //Fermer le modal
                setEditModal(false)
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des roles
                    fetchTranchesscolarites()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                //Fermer le modal
                setEditModal(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'edition de role
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                <div className="col-md-6">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleTrancheScolarite"
                        type="text"
                        value={editFormData.libelleTrancheScolarite}
                        onChange={handleEditChange}
                        placeholder="Exemple : ADMIN"
                        required={true}
                        name="libelleTrancheScolarite"
                        style={{ "textTransform": "uppercase" }}
                    />

                    {errors.libelleTrancheScolarite && (
                        <div className="alert alert-danger">
                            {errors.libelleTrancheScolarite}
                        </div>
                    )}
                </div>
                <div className="col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Pourcentage <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-pourcentageTrancheScolarite"
                        type="number"
                        value={editFormData.pourcentageTrancheScolarite}
                        onChange={handleEditChange}
                        required={true}
                        name="pourcentageTrancheScolarite"
                    />

                    {errors.pourcentageTrancheScolarite && (
                        <div className="alert alert-danger">
                            {errors.pourcentageTrancheScolarite}
                        </div>
                    )}
                </div>

                <div className="col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Date délai <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-datedelaiTrancheScolarite"
                        type="date"
                        value={dayjs(editFormData.datedelaiTrancheScolarite).format("YYYY-MM-DD")}
                        onChange={handleEditChange}
                        required={true}
                        name="datedelaiTrancheScolarite"
                    />


                    {errors.datedelaiTrancheScolarite && (
                        <div className="alert alert-danger">
                            {errors.datedelaiTrancheScolarite}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Statuts <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="statutId" id="bs-validation-statutId" value={editFormData.statutId} onChange={handleEditChange} required>
                        <option value="" disabled selected>Sélectionnez une valeur</option>
                        {statuts.length > 0 && statuts.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleStatut}</option>
                        ))}
                    </Form.Select>

                    {errors.statutId && (
                        <div className="alert alert-danger">
                            {errors.statutId}
                        </div>
                    )}

                </div>
            </div>

            <div className="row mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionTrancheScolarite" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionTrancheScolarite"
                    onChange={handleEditChange}
                    name="descriptionTrancheScolarite"
                    rows="3"
                    value={editFormData.descriptionTrancheScolarite}
                ></textarea>

                {errors.descriptionTrancheScolarite && (
                    <div className="alert alert-danger">
                        {errors.descriptionTrancheScolarite}
                    </div>
                )}

            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );


    useEffect(() => {
        fetchTranchesscolarites();
        fetchStatuts();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />


                {/* Responsive Datatable */}
                <div className="card shadow-lg mt-3 mb-3">
                    <h5 className="card-header">Liste des tranches scolarités &nbsp;&nbsp;
                        <Button className="rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
                            <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une tranche</Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Libelle </th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Pourcentage/tranche.S</th>
                                    <th className="cell text-white">Date delai/tranche.S</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tranchesscolarites.length > 0 && tranchesscolarites.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.libelleTrancheScolarite}
                                        </td>
                                        <td className="cell">{item.descriptionTrancheScolarite}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.pourcentageTrancheScolarite}</span></td>
                                        <td className="cell">
                                            <span>{dayjs(item.datedelaiTrancheScolarite).format("DD/MM/YYYY")}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>

            {/* Modal Ajout des roles*/}
            <CustomAddModal
                modalTitle="Enregistrement tranche scolarité"
                modalContent={addModalContent}
                visible={isVisible}
                close={() => setIsVisible(false)}
            />

            {/**End Modal Ajout des roles*/}

            {/* Modal Edition des roles*/}
            <CustomEditModal
                modalTitle="Modification tranche scolarité"
                modalContent={editModalContent}
                visible={editModal}
                close={() => setEditModal(false)}
            />

            {/**End Modal Edition des roles*/}

        </Layout>
    )
}